import React from "react";
import { Container, Box, Link } from "@material-ui/core";
import { FaFacebook } from "react-icons/fa";
import { AiFillTwitterCircle, AiFillInstagram } from "react-icons/ai";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: "0",
    width: "max-content",
    justifyContent: "space-around",
    marginLeft: 0,
    marginBottom: (props) => props.marginBottom,
  },
  boxStyle: {
    display: "inline",
    fontSize: "28px",
    color: theme.palette.secondary.main,
    marginRight: "0.5em",
    "& :hover": {
      color: theme.palette.primary.main,
    },
  },
}));
const SocialBar = (props) => {
  const classes = useStyles(props);
  return (
    <Container className={classes.root} maxWidth="sm">
      <Link
        href="https://www.facebook.com/natakallam2015"
        rel="noopener noreferrer"
        target="_blank"
      >
        <Box className={classes.boxStyle}>
          <FaFacebook style={{ fontSize: "24.4px", marginBottom: "0.11em" }} />
        </Box>
      </Link>
      <Link
        href="https://twitter.com/NaTakallam"
        rel="noopener noreferrer"
        target="_blank"
      >
        <Box className={classes.boxStyle}>
          <AiFillTwitterCircle />
        </Box>
      </Link>
      <Link
        href="https://www.instagram.com/natakallam/"
        rel="noopener noreferrer"
        target="_blank"
      >
        <Box className={classes.boxStyle}>
          <AiFillInstagram />
        </Box>
      </Link>
    </Container>
  );
};

export default SocialBar;
